/* eslint-disable */
import { locales } from '../translations/locales';
import { ModuleRP } from '../components/ModRP';

export default class Bip {
    constructor(locale, userName) {
        this.on = false;
        this.alarmOn = false;
        this.messageOn = false;
        this.name = userName;
        this.connect = false;
        this.message = {
            date: '',
            text: '',
        };
        this.oldMessage = {
            date: '',
            text: '',
        };
        this.screenOn = false;
        this.locale = locale;
        this.listeners = []; // Pour stocker les listeners
        this.vibreur = new Audio('/sounds/vibreur.ogg');
        this.vibreur.volume = 0.1;
        this.clic = new Audio('/sounds/clic.ogg');
        this.sonnerie = new Audio('/sounds/bip.ogg');
        this.callback = null;
    };

    programOffScreen = (delay) => {
        clearTimeout(this.callback);
        this.callback = setTimeout(() => this.offScreen(), delay);
    };

    bip = () => {
        clearTimeout(this.callback);
        this.screenOn = true;
        this.vibreur.play();
        this.vibreur.loop = true;
        this.sonnerie.play();
        this.sonnerie.loop = true;
        this.sonnerie.volume = 0.1;
        this.notifyListeners();
    };

    newAlert = (message) => {
        this.message.date = message.date;
        this.message.text = `${locales[this.locale].sga[message.text.category]} ${message.text.qualification}\n${message.text.location}\n${message.text.vehicle} ${message.text.skill}`;
        this.alarmOn = true;
        this.bip();
    };

    newMessage = (message) => {
        this.message.date = message.date;
        if (message.text === 'CANCELLED') {
            message.text = locales[this.locale].bip.cancelled;
        } else if (message.text === 'DISCONNECTED') {
            message.text = locales[this.locale].bip.disconnected;
            this.on = false;
        }
        this.message.text = message.text;
        this.messageOn = true;
        this.bip();
    };

    addListener(listener) {
        this.listeners.push(listener);
    };

    notifyListeners() {
        this.listeners.forEach((listener) => listener(this));
    };

    pressButton = () => {
        this.clic.play();
        this.vibreur.pause();
        this.sonnerie.pause();
        if (!this.on) {
            this.allumer();
        }
        this.screenOn = true;
        if (this.alarmOn || this.messageOn) {
            this.alarmOn = false;
            this.messageOn = false;
        }
        if (this.message.text === '') {
            this.message.text = this.oldMessage.text;
            this.message.date = this.oldMessage.date;
        }
        this.notifyListeners(); // Notifier les listeners
        this.programOffScreen(4000);
    };

    allumer = () => {
        this.on = true;
        this.screenOn = true;
        this.message.text = locales[this.locale].bip.loading;
        this.notifyListeners(); // Notifier les listeners
        ModuleRP.allumerBip();
        this.vibreur.play();
        setTimeout(() => this.vibreur.pause(), 500);
    };

    setLocale = (locale) => {
        this.locale = locale;
        this.notifyListeners(); // Notifier les listeners
    };

    offScreen = () => {
        this.screenOn = false;
        this.oldMessage.text = this.message.text;
        this.oldMessage.date = this.message.date;
        this.message.text = '';
        this.message.date = '';
        this.notifyListeners(); // Notifier les listeners
    };
};
